import { buildErrorsFromMsgs } from '../utils/errorHandling';
export const SEND_FIND_REGISTRY_DATA = 'SEND_FIND_REGISTRY_DATA';
export const CLEAR_REGISTRY_DATA = 'CLEAR_REGISTRY_DATA';

export function sendFindRegistryData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: SEND_FIND_REGISTRY_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs
        }
    };
}

export function clearRegistryData() {
    return {
        type: CLEAR_REGISTRY_DATA,
        payload: {}
    };
}
